import React from "react";
import Translator from "Languages/Utility/Translator";
import { Grid } from "@material-ui/core";
import * as Icons from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

export default function PeriodDetailsShow({ data }) {
  const { PriceCalcList, DiscountCalcPrice, PricePayment } = data;
  const { t } = useTranslation();
  return (
    <Grid className="periodDetailsShow">
      <p>
        <Icons.InfoSquare size={15} className="ms-1" />
        {t("sapg_periodsDetail")}
      </p>
      {PriceCalcList ? (
        <p>
          <Translator id="totalAmounts" />
          <strong> {PriceCalcList.toLocaleString()}</strong>
          <Translator id="moneyUnit" />
        </p>
      ) : (
        ""
      )}
      {DiscountCalcPrice ? (
        <p>
          <Translator id="periodDetailDiscount" />
          <strong> {DiscountCalcPrice.toLocaleString()}</strong>
          <Translator id="moneyUnit" />
        </p>
      ) : (
        ""
      )}
      {PricePayment ? (
        <p>
          <Translator id="userIncreaseDetailPriceShow" />
          <strong>{PricePayment.toLocaleString()}</strong>
          <Translator id="moneyUnit" />
        </p>
      ) : (
        ""
      )}
    </Grid>
  );
}
